import {RecommendationsContextWithOffers} from '@/views/amex/app-types';
import {formatBudget} from '@mobi-components/amex-bluesky-components';
import {PoiItem} from '@mobi-components/amex-poi-details-view';
import {CandidatePoiItem} from '@mobi-components/global-solution';

export const mapToPoiItem = (
  poi: CandidatePoiItem | undefined,
  activeSolutionFilters: Record<string, boolean> = {},
): PoiItem | null => {
  if (!poi) {
    return null;
  }
  const indexedImg = new Array(5)
    .fill(null)
    .map((_, index) => (((poi.images as unknown) || []) as string[])[index] || '');
  const allTags = (poi.tags || [])
    .concat(poi.types || [])
    .filter((r, x, self) => self.indexOf(r) === x)
    .map((x) => ({name: x, isActive: false}));
  const matchedTags = allTags
    .filter((x) => activeSolutionFilters[x.name.toLowerCase()])
    .map((x) => ({...x, isActive: true}))
    .slice(0, 3);
  const otherTags = allTags
    .filter((x) => !activeSolutionFilters[x.name.toLowerCase()])
    .map((x) => ({...x, isActive: false}))
    .slice(0, 6);

  return {
    ...poi,
    categories: poi.categories,
    description: poi.description,
    img: poi.images?.medium,
    images: [...indexedImg].filter(Boolean),
    tags: [...matchedTags, ...otherTags],
    location: poi.location,
    price: poi.prices?.length ? formatBudget(poi.prices[0].amount, poi.prices[0].currency, 'Points') : '',
    offers: (poi as RecommendationsContextWithOffers).offers || [],
    //@ts-ignore
    parent: poi.parent_id,
    //@ts-ignore
    children: poi.children_ids,
  };
};
